import { EnsureAuth, RootRedirector } from '../Components';
import { LegacyRoutes } from './LegacyRoutes';
import { EcosystemRoutes } from './EcosystemRoutes';

export function AppRoutes() {
  return [
    {
      path: '/',
      Component: EnsureAuth,
      children: [...AppRootRedirector(), ...LegacyRoutes(), ...EcosystemRoutes()],
    },
  ];
}

function AppRootRedirector() {
  return [{ index: true, Component: RootRedirector }];
}
